var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"goTop"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.goTopShow),expression:"goTopShow"}],staticClass:"goTop",on:{"click":_vm.goTop}},[_c('img',{attrs:{"src":require("../../assets/imgs/backtop.png"),"alt":""}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }